const MOBILE = "mobile";
const DESKTOP = "desktop";

const Flow = {
  MOBILE,
  DESKTOP,
} as const;

export default Flow;
